
import "./style.css";
import NavBar from "./components/NavBar";
import Carusell from "./components/Carusell";
import Intro from "./components/Intro";
import Products from "./components/Products";
import Baterias from "./components/Baterias";
import Team from "./components/Team";
import Videos from "./components/Videos";
import Typewrite from "./components/Typewrite";
import Map from "./components/Map";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";

function App() {
  return (
      <>
          {/* NAVBAR   */}
          <NavBar />
          <Carusell />
          <Intro />
          <Products />
          <Baterias/>          
          <Team />
          <Videos />
          <Typewrite />
          <Map />
          <Contacto />
          <Footer />
          <div className=" container-fluid     mamei text-white text-center">
              <div className="row">
                  <div className="col ">
                      <h4>¿Necesitas una pagina web?</h4>
                  </div>
              </div>
          </div>
      </>
  );
}

export default App;
